export const AUTH = {
    loginEmailInput: "login-email-input",
    loginPasswordInput: "login-password-input",
    loginSubmitBtn: "login-submit-btn",
    loginError: "login-error",
    logoutBtn: "sidebar-logout-btn",
};

export const NAV = {
    sidebar: "app-sidebar",
    dashboardLink: "nav-dashboard",
    payrunsLink: "nav-payruns",
    employeesLink: "nav-employees",
    usersLink: "nav-users",
    kpChip: "sidebar-kp-chip",
};

export const EMPLOYEES = {
    page: "employees-page",
    addBtn: "employees-add-btn",
    row: (id) => `employee-row-${id}`,
    editBtn: (id) => `employee-edit-btn-${id}`,
    searchInput: "employees-search-input",
    drawer: "employee-drawer",
    drawerName: "employee-drawer-name",
    drawerPosition: "employee-drawer-position",
    drawerNumber: "employee-drawer-number",
    drawerRate: "employee-drawer-rate",
    drawerDeps: "employee-drawer-deps",
    drawerDepsForRebate: "employee-drawer-deps-for-rebate",
    drawerTaxStatus: "employee-drawer-tax-status",
    drawerTravel: "employee-drawer-travel",
    drawerHousing: "employee-drawer-housing",
    drawerOther: "employee-drawer-other",
    drawerBsb: "employee-drawer-bsb",
    drawerAcct: "employee-drawer-acct",
    drawerAcctName: "employee-drawer-acct-name",
    drawerNotes: "employee-drawer-notes",
    drawerSaveBtn: "employee-drawer-save-btn",
    drawerRemoveBtn: "employee-drawer-remove-btn",
    drawerCloseBtn: "employee-drawer-close-btn",
    // Opening YTD (prior-system carry-in). Admin-only section.
    drawerOpeningSection: "employee-drawer-opening-section",
    drawerOpeningToggle: "employee-drawer-opening-toggle",
    drawerOpeningGross: "employee-drawer-opening-gross",
    drawerOpeningTax: "employee-drawer-opening-tax",
    drawerOpeningNet: "employee-drawer-opening-net",
    drawerOpeningAsAt: "employee-drawer-opening-as-at",
    drawerOpeningAudit: "employee-drawer-opening-audit",
    // Biometric integration fields (admin)
    drawerEmpCode: "employee-drawer-emp-code",
    drawerRosteredStart: "employee-drawer-rostered-start",
    drawerRosteredFinish: "employee-drawer-rostered-finish",
    // Leave balances & loan opening — nullable "not supplied" state
    drawerLeaveSection: "employee-drawer-leave-section",
    drawerLeaveAlHours: "employee-drawer-leave-al-hours",
    drawerLeaveSlHours: "employee-drawer-leave-sl-hours",
    drawerLeaveAlNotSupplied: "employee-drawer-leave-al-notsupplied",
    drawerLeaveSlNotSupplied: "employee-drawer-leave-sl-notsupplied",
    drawerLeaveAdjustBtn: "employee-drawer-leave-adjust-btn",
    drawerLoanOpeningKina: "employee-drawer-loan-opening-kina",
    drawerLoanOpeningNotSupplied: "employee-drawer-loan-opening-notsupplied",
    // Round 16 · Bank accounts list — several accounts per employee,
    // one default, optional 18-char lodgement reference (Irene's rule).
    banksSection: "employee-drawer-banks-section",
    banksAddBtn: "employee-drawer-banks-add-btn",
    bankRow: (id) => `employee-drawer-bank-row-${id}`,
    bankBsb: (id) => `employee-drawer-bank-bsb-${id}`,
    bankAcct: (id) => `employee-drawer-bank-acct-${id}`,
    bankTitle: (id) => `employee-drawer-bank-title-${id}`,
    bankNickname: (id) => `employee-drawer-bank-nickname-${id}`,
    bankDefault: (id) => `employee-drawer-bank-default-${id}`,
    bankLref: (id) => `employee-drawer-bank-lref-${id}`,
    bankLrefCount: (id) => `employee-drawer-bank-lref-count-${id}`,
    bankRemoveBtn: (id) => `employee-drawer-bank-remove-${id}`,
};

// Round 17b · Bulk employee CSV import panel — paste box, dry-run
// preview with row-numbered errors, skip_duplicate highlighting, and
// a commit button that flips dry_run to false once the operator has
// eyeballed the envelope.
export const BULK_CSV = {
    openBtn: "bulk-csv-open-btn",
    panel: "bulk-csv-panel",
    closeBtn: "bulk-csv-close-btn",
    textarea: "bulk-csv-textarea",
    previewBtn: "bulk-csv-preview-btn",
    commitBtn: "bulk-csv-commit-btn",
    summaryTotal: "bulk-csv-summary-total",
    summaryValid: "bulk-csv-summary-valid",
    summaryInvalid: "bulk-csv-summary-invalid",
    summaryDup: "bulk-csv-summary-duplicates",
    headerError: "bulk-csv-header-error",
    rowsTable: "bulk-csv-rows-table",
    row: (n) => `bulk-csv-row-${n}`,
    rowErrors: (n) => `bulk-csv-row-errors-${n}`,
    templateBtn: "bulk-csv-template-btn",
};

// Round 18 · IRC Form S2 monthly remittance. Screen sits under
// /reports/irc-s2. Month picker + five-box preview + "Download PDF".
// Assumption chips surface the three "Awaiting client answer" flags.
export const IRC_S2 = {
    page: "irc-s2-page",
    monthPicker: "irc-s2-month-picker",
    reloadBtn: "irc-s2-reload-btn",
    downloadBtn: "irc-s2-download-btn",
    lodgeBtn: "irc-s2-lodge-btn",
    supersedeBtn: "irc-s2-supersede-btn",
    supersedeDialog: "irc-s2-supersede-dialog",
    supersedeReasonInput: "irc-s2-supersede-reason",
    supersedeConfirmBtn: "irc-s2-supersede-confirm",
    supersedeCancelBtn: "irc-s2-supersede-cancel",
    historyList: "irc-s2-history-list",
    historyItem: (id) => `irc-s2-history-item-${id}`,
    lodgedBadge: "irc-s2-lodged-badge",
    driftBanner: "irc-s2-drift-banner",
    incompleteBanner: "irc-s2-incomplete-banner",
    lodgeableBadge: "irc-s2-lodgeable-badge",
    box10: "irc-s2-box-10",
    box20: "irc-s2-box-20",
    box30: "irc-s2-box-30",
    box40: "irc-s2-box-40",
    box50: "irc-s2-box-50",
    assumption: (key) => `irc-s2-assumption-${key}`,
    includedPeriods: "irc-s2-included-periods",
    auditRow: (id) => `irc-s2-audit-row-${id}`,
    navLink: "nav-irc-s2",
};

export const IRC_S1 = {
    page: "irc-s1-page",
    yearPicker: "irc-s1-year-picker",
    reloadBtn: "irc-s1-reload-btn",
    downloadBtn: "irc-s1-download-btn",
    incompleteBanner: "irc-s1-incomplete-banner",
    travelColumnBadge: "irc-s1-travel-column-badge",
    row: (id) => `irc-s1-row-${id}`,
    rowCol1: (id) => `irc-s1-row-${id}-col1`,
    rowCol2: (id) => `irc-s1-row-${id}-col2`,
    rowCol3: (id) => `irc-s1-row-${id}-col3`,
    rowCol6: (id) => `irc-s1-row-${id}-col6`,
    rowDeps: (id) => `irc-s1-row-${id}-deps`,
    totalWages: "irc-s1-total-wages",
    totalAllowances: "irc-s1-total-allowances",
    totalBenefits: "irc-s1-total-benefits",
    totalSwt: "irc-s1-total-swt",
    navLink: "nav-irc-s1",
};

export const IRC_S6 = {
    page: "irc-s6-page",
    yearPicker: "irc-s6-year-picker",
    downloadBtn: "irc-s6-download-btn",
    reconcileBreakBanner: "irc-s6-reconcile-break-banner",
    reconcileOkBadge: "irc-s6-reconcile-ok-badge",
    monthlyBox: (n) => `irc-s6-box-${n}`,
    total1: "irc-s6-total-1",
    total2: "irc-s6-total-2",
    navLink: "nav-irc-s6",
};

export const SETUP = {
    page: "setup-employees-page",
    row: (i) => `setup-row-${i}`,
    fieldRate: (i) => `setup-field-rate-${i}`,
    fieldDeps: (i) => `setup-field-deps-${i}`,
    fieldEmpCode: (i) => `setup-field-emp-code-${i}`,
    fieldAllowance: (i) => `setup-field-allowance-${i}`,
    confirmBtn: (i) => `setup-confirm-btn-${i}`,
    alreadyExists: (i) => `setup-exists-chip-${i}`,
    navLink: "nav-setup-employees",
};

export const SETTINGS_NAV = {
    payrollLink: "nav-settings-payroll",
    holidaysLink: "nav-settings-holidays",
};

export const PAYROLL_SETTINGS = {
    page: "payroll-settings-page",
    row: (key) => `payroll-setting-row-${key}`,
    valueInput: (key) => `payroll-setting-value-${key}`,
    confirmedToggle: (key) => `payroll-setting-confirmed-${key}`,
    saveBtn: (key) => `payroll-setting-save-${key}`,
    globalSaveBtn: "payroll-setting-global-save-btn",
};

export const HOLIDAYS = {
    page: "public-holidays-page",
    addBtn: "public-holidays-add-btn",
    row: (id) => `public-holiday-row-${id}`,
    editName: (id) => `public-holiday-name-${id}`,
    editDate: (id) => `public-holiday-date-${id}`,
    editConfirmed: (id) => `public-holiday-confirmed-${id}`,
    deleteBtn: (id) => `public-holiday-delete-${id}`,
    newName: "public-holiday-new-name",
    newDate: "public-holiday-new-date",
    newSaveBtn: "public-holiday-new-save-btn",
};

export const BIOMETRIC = {
    modalTab: "import-tab-bio",
    textarea: "biometric-textarea",
    previewBtn: "biometric-preview-btn",
    previewResult: "biometric-preview-result",
    exceptionsPanel: "biometric-exceptions-panel",
    exception: (i) => `biometric-exception-${i}`,
    unmappedRow: (i) => `biometric-unmapped-${i}`,
    absentRow: (i) => `biometric-absent-${i}`,
    dayRow: (empId, i) => `biometric-day-${empId}-${i}`,
    applyBtn: "biometric-apply-btn",
    ackModal: "biometric-ack-modal",
    ackCheckbox: "biometric-ack-checkbox",
    overwriteCheckbox: "biometric-overwrite-checkbox",
    ackConfirmBtn: "biometric-ack-confirm-btn",
    // Round 13 · Group C. Row-count deltas are surfaced but no longer
    // fatal — Michael ticks the ack + applies. Unmatched employees
    // (name + code) get their own header row so nothing is hidden.
    rowCountDeltaAck: "biometric-rowcount-delta-ack",
    rowCountDeltaBanner: "biometric-rowcount-delta-banner",
    unmatchedHeader: "biometric-unmatched-header",
    dateSourceChip: "biometric-date-source-chip",
};

export const LEDGERS = {
    travelSection: "travel-ledger-section",
    travelAddDate: "travel-add-date",
    travelAddAmount: "travel-add-amount",
    travelAddNote: "travel-add-note",
    travelAddBtn: "travel-add-btn",
    travelPreviewBtn: "travel-preview-btn",
    travelRow: (id) => `travel-row-${id}`,
    travelDeleteBtn: (id) => `travel-delete-${id}`,
    loanSection: "loan-ledger-section",
    loanBalance: "loan-balance",
    loanAddType: "loan-add-type",
    loanAddDate: "loan-add-date",
    loanAddAmount: "loan-add-amount",
    loanAddNote: "loan-add-note",
    loanAddBtn: "loan-add-btn",
    loanRow: (id) => `loan-row-${id}`,
};

export const PAYRUN_LOAN = {
    header: "payrun-loan-header",
    cell: (lineId) => `payrun-loan-cell-${lineId}`,
    input: (lineId) => `payrun-loan-input-${lineId}`,
    warning: (lineId) => `payrun-loan-warning-${lineId}`,
};

export const USERS = {
    page: "users-page",
    addBtn: "users-add-btn",
    row: (id) => `user-row-${id}`,
    resetBtn: (id) => `user-reset-${id}`,
    deleteBtn: (id) => `user-delete-${id}`,
    modalEmail: "user-modal-email",
    modalName: "user-modal-name",
    modalRole: "user-modal-role",
    modalPassword: "user-modal-password",
    modalSaveBtn: "user-modal-save-btn",
    roleSelect: (id) => `user-role-select-${id}`,
    roleSaveBtn: (id) => `user-role-save-${id}`,
    roleConfirmModal: "user-role-confirm-modal",
    roleConfirmBtn: "user-role-confirm-btn",
    roleCancelBtn: "user-role-cancel-btn",
    lastAdminBadge: (id) => `user-last-admin-badge-${id}`,
};

export const DASH = {
    page: "dashboard-page",
    newPeriodBtn: "dash-new-period-btn",
    continueBtn: "dash-continue-btn",
    kpiStaff: "dash-kpi-staff",
    kpiGross: "dash-kpi-gross",
    kpiTax: "dash-kpi-tax",
    kpiNet: "dash-kpi-net",
    recentRow: (id) => `dash-recent-${id}`,
};

export const NEW_PERIOD = {
    modal: "new-period-modal",
    ppeInput: "new-period-ppe",
    confirmBtn: "new-period-confirm",
    cancelBtn: "new-period-cancel",
};

export const PAYRUN = {
    listPage: "payruns-list-page",
    listRow: (id) => `payrun-list-row-${id}`,
    page: "payrun-page",
    importBtn: "payrun-import-btn",
    approveBtn: "payrun-approve-btn",
    banner: "payrun-sickph-banner",
    bannerDismiss: "payrun-banner-dismiss",
    workflowStep: (n) => `payrun-step-${n}`,
    row: (id) => `payrun-row-${id}`,
    rowName: (id) => `payrun-row-name-${id}`,
    cellRate: (id) => `payrun-cell-rate-${id}`,
    cellDeps: (id) => `payrun-cell-deps-${id}`,
    cellReg: (id) => `payrun-cell-reg-${id}`,
    cellTah: (id) => `payrun-cell-tah-${id}`,
    cellDbl: (id) => `payrun-cell-dbl-${id}`,
    cellSick: (id) => `payrun-cell-sick-${id}`,
    cellPh: (id) => `payrun-cell-ph-${id}`,
    cellPhTaken: (id) => `payrun-cell-ph-taken-${id}`,
    cellAlTaken: (id) => `payrun-cell-al-taken-${id}`,
    // Round 14 · Negative-leave warning. Warn (never block save) when
    // this line's AL/sick hours would push the projected balance below
    // zero. `from_cut_in_only` suppresses the warning — a "balance"
    // that starts at 0 has no meaning yet.
    cellAlWarn: (id) => `payrun-cell-al-warn-${id}`,
    cellSickWarn: (id) => `payrun-cell-sick-warn-${id}`,
    // Long-service leave — client-confirmed 2026-09 hardening 5.
    // Paid at ordinary rate, hits taxable_gross, does NOT accrue AL/SL.
    // Sits between AL Tkn and the Allowances cell.
    cellLsl: (id) => `payrun-cell-lsl-${id}`,
    cellAllow: (id) => `payrun-cell-allow-${id}`,
    // B3 Allowances Chip — one cell surface, one popover with all 5
    // recurring categories + one-off. Bus/school write to per-line
    // overrides; travel/housing/other are master-only with a link that
    // opens the employee drawer.
    allowChip: (id) => `payrun-allow-chip-${id}`,
    allowChipTotal: (id) => `payrun-allow-chip-total-${id}`,
    allowPopover: (id) => `payrun-allow-popover-${id}`,
    allowBusInput: (id) => `payrun-allow-bus-${id}`,
    allowSchoolInput: (id) => `payrun-allow-school-${id}`,
    allowOneOffInput: (id) => `payrun-allow-oneoff-${id}`,
    allowTravelRead: (id) => `payrun-allow-travel-${id}`,
    allowHousingRead: (id) => `payrun-allow-housing-${id}`,
    allowOtherRead: (id) => `payrun-allow-other-${id}`,
    allowEditEmployeeBtn: (id) => `payrun-allow-edit-employee-${id}`,
    allowPopoverTotal: (id) => `payrun-allow-popover-total-${id}`,
    // Round 16 · bank splits chip on the pay-line row. Shows N accounts,
    // opens a popover with per-run dollar splits + auto-remainder line.
    splitsChip: (id) => `payrun-splits-chip-${id}`,
    splitsPopover: (id) => `payrun-splits-popover-${id}`,
    splitsAmount: (lineId, accId) => `payrun-splits-amount-${lineId}-${accId}`,
    splitsRemainderRow: (id) => `payrun-splits-remainder-${id}`,
    splitsClearBtn: (id) => `payrun-splits-clear-${id}`,
    cellGross: (id) => `payrun-cell-gross-${id}`,
    cellTax: (id) => `payrun-cell-tax-${id}`,
    cellNet: (id) => `payrun-cell-net-${id}`,
    rowDetailBtn: (id) => `payrun-row-detail-${id}`,
    footerGross: "payrun-footer-gross",
    footerTax: "payrun-footer-tax",
    footerNet: "payrun-footer-net",
    kpiStaff: "payrun-kpi-staff",
    kpiGross: "payrun-kpi-gross",
    kpiTax: "payrun-kpi-tax",
    kpiNet: "payrun-kpi-net",
    lockedChip: "payrun-locked-chip",
    skippedRowsLink: "payrun-skipped-rows-link",
    skippedRowsModal: "payrun-skipped-rows-modal",
    skippedRowsClose: "payrun-skipped-rows-close",
};

export const IMPORT = {
    modal: "import-modal",
    tabPaste: "import-tab-paste",
    tabCsv: "import-tab-csv",
    tabBio: "import-tab-bio",
    textarea: "import-textarea",
    csvInput: "import-csv-input",
    applyBtn: "import-apply-btn",
    closeBtn: "import-close-btn",
    matchSummary: "import-match-summary",
    // 2-step reconciliation
    continueBtn: "import-continue-btn",
    reconcilePanel: "import-reconcile-panel",
    reconcileBack: "import-reconcile-back",
    reconcileConfirmBtn: "import-reconcile-confirm-btn",
    reconcileSummary: "import-reconcile-summary",
    unmatchedRow: (i) => `import-unmatched-row-${i}`,
    unmatchedSelect: (i) => `import-unmatched-select-${i}`,
    unmatchedSkip: (i) => `import-unmatched-skip-${i}`,
    matchedRow: (i) => `import-matched-row-${i}`,
};

export const LINE_DRAWER = {
    drawer: "payline-drawer",
    closeBtn: "payline-drawer-close",
    editProfileBtn: "payline-drawer-edit-profile",
    netAmount: "payline-drawer-net",
};

export const APPROVE = {
    page: "approve-page",
    kpiGross: "approve-kpi-gross",
    kpiTax: "approve-kpi-tax",
    kpiNet: "approve-kpi-net",
    approveBtn: "approve-confirm-btn",
    backBtn: "approve-back-btn",
    // Typed-confirm modal
    confirmModal: "approve-confirm-modal",
    confirmInput: "approve-confirm-input",
    confirmSubmitBtn: "approve-confirm-submit-btn",
    confirmCancelBtn: "approve-confirm-cancel-btn",
    confirmHelper: "approve-confirm-helper",
};

export const PROFILE = {
    changePasswordBtn: "sidebar-change-password-btn",
    seedFlag: "sidebar-seed-password-flag",
    modal: "change-password-modal",
    modalClose: "change-password-close",
    inputCurrent: "change-password-current",
    inputNew: "change-password-new",
    inputConfirm: "change-password-confirm",
    submitBtn: "change-password-submit",
    error: "change-password-error",
    // Dashboard banner
    seedBanner: "dashboard-seed-password-banner",
    seedBannerChangeBtn: "dashboard-seed-password-change-btn",
    seedBannerDismiss: "dashboard-seed-password-dismiss",
};

export const GUIDE = {
    openBtn: "nav-user-guide-btn",
    prompt: "guide-first-login-prompt",
    promptDismiss: "guide-first-login-dismiss",
    panel: "guide-panel",
    closeBtn: "guide-panel-close",
    searchInput: "guide-panel-search",
    chapterLink: (id) => `guide-chapter-link-${id}`,
    body: "guide-panel-body",
    prevBtn: "guide-panel-prev",
    nextBtn: "guide-panel-next",
    downloadPdfBtn: "guide-panel-download-pdf",
};

export const SUCCESS = {
    page: "success-page",
    dlPayslipsZip: "dl-payslips-zip",
    dlBank: "dl-bank-csv",
    dlWestpacDe: "dl-westpac-de",
    dlIrc: "dl-irc-pdf",
    dlPayRun: "dl-payrun-pdf",
    dlPayslip: (id) => `dl-payslip-${id}`,
    bankExcludedBanner: "bank-excluded-banner",
    bankExcludedItem: (id) => `bank-excluded-${id}`,
    bankPayeeCount: "bank-payee-count",
    // Round 16 · Westpac DE download + envelope banner.
    westpacExcludedBanner: "westpac-excluded-banner",
    westpacExcludedItem: (id) => `westpac-excluded-${id}`,
    westpacCreditCount: "westpac-credit-count",
    westpacConfigMissing: "westpac-config-missing",
    // Round 21 · reopen from the /complete screen (admin only). When the
    // period's month has a lodged S2, the dialog demands a note before
    // sending the ack.
    reopenBtn: "success-reopen-btn",
    lodgedChip: "success-lodged-chip",
    reopenDialog: "success-reopen-dialog",
    reopenNoteInput: "success-reopen-note",
    reopenConfirmBtn: "success-reopen-confirm",
    reopenCancelBtn: "success-reopen-cancel",
};

// Aggregated approve-gate acknowledgement dialog on the pay-run screen.
export const APPROVE_GATE = {
    dialog: "approve-gate-dialog",
    blockItem: (idx) => `approve-gate-block-${idx}`,
    ackItem: (code) => `approve-gate-ack-${code}`,
    ackCheckbox: (code) => `approve-gate-ack-checkbox-${code}`,
    confirmBtn: "approve-gate-confirm",
    cancelBtn: "approve-gate-cancel",
};
